import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const QA = [
  { q: "How does weight-based pricing work?", a: "We weigh your waste at our facility right after collection. You only pay for the actual kilos we take, plus any applicable bulky-item surcharges and a small loading fee if we load." },
  { q: "Self-load vs we-load — what's the difference?", a: "Self-load means you have your items ready to go in piles or bags, ready to be quickly transferred. We-load means our team will load directly from where it's safe to access roadside or driveway." },
  { q: "Do I need a skip permit?", a: "No. Because we collect on the day, there are no skips on the road and no permits required." },
  { q: "What about hazardous waste?", a: "We can't take asbestos, paint, oils, or large quantities of chemicals. Contact us first if you're unsure." },
  { q: "How is the deposit calculated?", a: "Your deposit is a small percentage of your estimated total (with a fair minimum) to secure your slot. The balance is settled after final weighing." },
  { q: "What happens if I underestimate the weight?", a: "We weigh on the day and your final price adjusts based on the actual weight. You pay only for what we take — that goes both ways." },
  { q: "Which areas do you cover?", a: "We currently operate across the UK in selected service zones. Outside the standard area, a small mileage charge may apply." },
];

export default function FAQ() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="text-xs uppercase tracking-[0.2em] text-gray-500">FAQ</div>
      <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter text-white">Common <span className="text-[#8DC63F]">questions.</span></h1>
      <p className="text-gray-400 mt-3">If you can&apos;t find your answer here, drop us a message on the contact page.</p>

      <Accordion type="single" collapsible className="mt-8" data-testid="faq-accordion">
        {QA.map((item, i) => (
          <AccordionItem key={i} value={`faq-${i}`} className="border-b border-[#232428]">
            <AccordionTrigger className="font-display text-lg text-left text-white hover:text-[#8DC63F]" data-testid={`faq-question-${i}`}>{item.q}</AccordionTrigger>
            <AccordionContent className="text-gray-300 text-sm" data-testid={`faq-answer-${i}`}>{item.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
